import React from 'react';

import { Field } from 'redux-form';

import { Input, RadioButtonsGroup } from 'components';
import { useStyles } from './styles';


const PAYMENTS_INPUT_FIElDS = {
  PayPal: [
    {
      name: 'clientId',
      placeholder: 'Client ID',
      label: 'Client ID *'
    },
    {
      name: 'clientSecret',
      placeholder: 'Client secret',
      label: 'Client secret *'
    }
  ],
  Stripe: [
    {
      name: 'publishableKey',
      placeholder: 'Publishable key',
      label: 'Publishable key *'
    },
    {
      name: 'secretKey',
      placeholder: 'API password',
      label: 'Secret key *'
    }
  ],
  payOnArrival: [
    {
      name: 'payOnArrivalPossibility',
      title: 'Pay on arrival'
    }
  ]
};
const PaymentsInputFields = ({ field,   paymentSystem, isUpdate }) => {
  const classes = useStyles();
  return (
    <div className={classes.inputRow}>
      {paymentSystem &&
        paymentSystem !== 'payOnArrival' &&
        PAYMENTS_INPUT_FIElDS[paymentSystem].map(
          (paymentSystemDetails, index) => {
            const isSecretKey = paymentSystemDetails.name === 'secretKey';
            return (
              <Field
                key={index}
                name={`${field}.${paymentSystemDetails.name}`}
                className={classes.input}
                placeholder={paymentSystemDetails.placeholder}
                label={paymentSystemDetails.label}
                component={Input}
                disabled={ isUpdate && isSecretKey}
              />
            );
          }
        )}
      {paymentSystem &&
        paymentSystem === 'payOnArrival' &&
        PAYMENTS_INPUT_FIElDS[paymentSystem].map(
          (paymentSystemDetails, index) => {
            return (
              <Field
                key={index}
                name={`${field}.${paymentSystemDetails.name}`}
                label={paymentSystemDetails.title}
                list={['Yes', 'No']}
                component={RadioButtonsGroup}
              />
            );
          }
        )}
    </div>
  );
};

export default PaymentsInputFields;
